import { useState, useEffect } from 'react';

import { ScrollDirection, ScrollState } from '@common/types/ScrollDirection.type';

const useScrollDirection = (): ScrollState => {
  const [scrollState, setScrollState] = useState<ScrollState>({
    direction: ScrollDirection.DOWN,
    previousPosition: 0,
  });

  const handleScroll = (): void => {
    const currentPosition = window.pageYOffset;

    setScrollState({
      direction: currentPosition > scrollState.previousPosition ? ScrollDirection.DOWN : ScrollDirection.UP,
      previousPosition: currentPosition,
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollState]);

  return scrollState;
};

export default useScrollDirection;
